import styled from 'styled-components';

export default styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 1%;
`;
